<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" :loading="loadingServerSide">
      <template v-slot:item="{ item }">
        <tr v-if="item.local">
          <td class="warning">{{ item.supplier_id }}-{{ item.stock_code }}</td>
          <td class="warning">{{ item.product_name }}</td>
          <td class="warning">{{ item.quantity }} {{ item.unit }}</td>
          <td class="warning">{{ item.retail }}</td>
          <td class="warning" style="text-align: right">{{ formatMoney(item.quantity * item.retail) }}</td>
          <td class="warning">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" text dark x-small v-bind="attrs" v-on="on" color="red"
                  @click="removeFromTempList(item.index)">
                  <v-icon dark>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-else>
          <td>{{ item.supplier_id }}-{{ item.stock_code }}</td>
          <td>{{ item.product_name }}</td>
          <td>{{ item.quantity }} {{ item.unit }}</td>
          <td>{{ item.retail }}</td>
          <td style="text-align: right">{{ formatMoney(item.quantity * item.retail) }}</td>
          <td>
            <v-tooltip bottom v-if="authPermissions.has('consumer_loans:edit')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" text dark x-small v-bind="attrs" v-on="on" color="yellow darken-3"
                  @click="editLoan(item)">
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" text dark x-small v-bind="attrs" v-on="on" color="red" @click="remove(item.id)"
                  v-if="authPermissions.has('consumer_loans:delete')">
                  <v-icon dark>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template v-slot:[`body.append`]>
        <tr>
          <th colspan="4"><span class="primary--text">Total Debt</span></th>
          <td style="text-align: right">{{ formatMoney(totalDebt) }}</td>
          <td></td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { moneyMixin } from '@/views/dashboard/mixins/helper.mixins'
import consumerLoanInventoryRepository from '@/repositories/consumer-loan-inventory.repository'
export default {
  name: 'index-consumer-loan-inventory',
  props: {
    propConsumerId: String,
    propConsumerLoanId: String,
  },
  data() {
    return {
      headers: [
        { text: 'Stock Code', sortable: false },
        { text: 'Name' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Price', value: 'retail' },
        { text: 'Total Amount', sortable: false },
        { text: 'Config', sortable: false },
      ],
      serverSideList: [],
      loadingServerSide: false,
    }
  },
  created() {
    this.getLoanInventory()
    this.initWebsocketEvents()
  },
  computed: {
    ...mapState({
      localList: state => state.consumerLoanInventory.tempList,
      consumerLoanInventoryUpdate: state => state.consumerLoanInventory.channelUpdate,
      authPermissions: state => state.auth.userPermissions,
    }),
    computedLocalList() {
      return this.localList
        .filter(e => e.consumer_loan_id === this.propConsumerLoanId)
        .map((e, index) => {
          return {
            ...e,
            local: true,
            index,
          }
        })
    },
    totalDebt() {
      return this.items.reduce((t, c) => {
        return t + (c.quantity * c.retail)
      }, 0)
    },
    items() {
      return this.computedLocalList.concat(this.serverSideList)
    },
  },
  watch: {
    consumerLoanInventoryUpdate() {
      this.getLoanInventory()
    },
  },
  methods: {
    ...mapActions({
      removeFromTempList: 'consumerLoanInventory/removeFromTempList',
    }),
    async getLoanInventory() {
      this.loadingServerSide = true
      const params = {
        consumer: this.propConsumerId,
        consumerLoan: this.propConsumerLoanId,
      }
      consumerLoanInventoryRepository.index(params)
        .then(({ data }) => { this.serverSideList = data })
        .catch(e => { })
        .then(() => { this.loadingServerSide = false })
    },
    // getLoanSuccess ({ data }) {
    //    = data.map(el => {
    //     const stock = el.stock
    //     delete el.stock
    //     delete el.supplier
    //     return {
    //       ...el,
    //       productName: stock.product_name,
    //     }
    //   })
    // },
    editLoan(item) {
      this.$emit('edit', item)
    },
    remove(id) {
      this.$confirm('Do you really want to delete this data?')
        .then(confirm => {
          if (!confirm) return
          this.deleteConsumerLoanInventory(id)
        })
    },
    deleteConsumerLoanInventory(id) {
      consumerLoanInventoryRepository.delete(id)
        .then()
    },
    initWebsocketEvents() {
      const { echo } = this.$store.state.websocket
      echo.channel('database-update')
        .listen('ConsumerLoanUpdated', this.getLoanInventory)
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
<style lang="scss" scoped>
.warning {
  background-color: #FBBC05;
}
</style>
